import { createContext, useContext, useState, useMemo, type ReactNode } from 'react';

interface TourContextType {
  onStartTour: (() => void) | null;
  setOnStartTour: (callback: (() => void) | null) => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export function TourProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [onStartTour, setOnStartTour] = useState<(() => void) | null>(null);

  const contextValue = useMemo(() => ({ onStartTour, setOnStartTour }), [onStartTour]);

  return (
    <TourContext.Provider value={contextValue}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}
